<div class="media-preview-grid" [ngClass]="size">
  <ng-container *ngFor="let item of media; let i = index; trackBy: trackByMediaUrl">
    <div class="media-item">
      <button *ngIf="showCloseButton" class="remove-btn" mat-icon-button (click)="removeFile(i)">
        <mat-icon>close</mat-icon>
      </button>

      <!-- Expired URL state -->
      <ng-container *ngIf="isUrlExpired(item)">
        <div class="file-info expired">
          <div class="icon">
            <mat-icon fontSet="material-icons-outlined">link_off</mat-icon>
          </div>
          <div class="file">
            <div class="file-name">
              <b>{{ getDisplayedFilename(item).name }}</b
              >{{ getDisplayedFilename(item).ext }}
            </div>
            <div class="file-size expired-text">Link expired</div>
          </div>
        </div>
      </ng-container>

      <!-- Valid URL states -->
      <ng-container *ngIf="!isUrlExpired(item)">
        <a *ngIf="isImage(item)" [href]="rawUrls[i]" target="_blank">
          <div
            class="image-placeholder"
            *ngIf="!loaded[i]"
            [style.width.px]="getPlaceholderDimensions().width"
            [style.height.px]="getPlaceholderDimensions().height"
          ></div>
          <img
            *ngIf="isImage(item)"
            [src]="mediaUrls[i]"
            alt="{{ item.filename }}"
            [hidden]="!loaded[i]"
            (load)="onImageLoad(i)"
          />
        </a>
        <a *ngIf="isPdf(item)" [href]="rawUrls[i]" target="_blank" class="file-link">
          <div *ngIf="showFilename" class="file-info">
            <div class="icon">
              <mat-icon fontSet="material-icons-outlined">picture_as_pdf</mat-icon>
            </div>
            <div class="file">
              <div class="file-name">
                <b>{{ getDisplayedFilename(item).name }}</b
                >{{ getDisplayedFilename(item).ext }}
              </div>
              <div *ngIf="showFilesize && item.size" class="file-size">
                {{ getDisplayedFilesize(item.size) }}
              </div>
            </div>
          </div>
        </a>
        <a
          *ngIf="!isImage(item) && !isPdf(item)"
          [href]="rawUrls[i]"
          target="_blank"
          class="file-link"
        >
          <div *ngIf="showFilename" class="file-info">
            <div class="icon">
              <mat-icon class="forty-five-clockwise">attach_file</mat-icon>
            </div>
            <div class="file">
              <div class="file-name">
                <b>{{ getDisplayedFilename(item).name }}</b
                >{{ getDisplayedFilename(item).ext }}
              </div>
              <div *ngIf="showFilesize && item.size" class="file-size">
                {{ getDisplayedFilesize(item.size) }}
              </div>
            </div>
          </div>
        </a>
      </ng-container>
    </div>
  </ng-container>
</div>
